import { render } from "./termandcondition.vue?vue&type=template&id=ad42d332"
import script from "./termandcondition.vue?vue&type=script&lang=js"
export * from "./termandcondition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__